import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import SectionFields from "../tabs/common/Section/SectionFields";
import { buildMinimumOrderField } from "../fields/commercialInformation";
import type { CommercialInfo } from "../../types";

export function ReadOnlyCommercialInfoContainer({
  commercialInformation,
}: {
  commercialInformation?: CommercialInfo;
}) {
  return (
    <Box data-testid="read-only-commercial-information-container">
      <SectionCollapsible label="Commercial Information">
        <SectionFields
          fields={[buildMinimumOrderField(commercialInformation)]}
          columns={2}
          fieldIdPrefix="read-only-commercial-information"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyCommercialInfoContainer;
